export default "__VITE_ASSET__B4Ww4YJl__"